import { TCards } from '@lbs/shared-rp-types'
import { FC } from 'react'
import { StyledCompactCard } from '../CardHolder.styles'

type Props = {
  cards: TCards[]
  cardSlots: number
}

const CompactCardsView: FC<Props> = ({ cards, cardSlots }) => {
  return (
    <>
      {cards.map((card, idx) => (
        <StyledCompactCard
          // eslint-disable-next-line react/no-array-index-key
          key={`${card}-${idx}`}
          value={card}
          index={idx}
          count={cardSlots}
        />
      ))}
    </>
  )
}

export default CompactCardsView
